import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_storage_lifecycleService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { environment?: string, sender?: string, receiver?: string, ingress_id?: string, egress_id?: string, transaction_id?: string, reference?: string, integration_name?: string, statuses?: string[], $top?: number, $skip?: number }): Promise<{ result?: { id?: string, ingress_type?: string, ingress_id?: string, transaction_id?: string, translation_status?: string, import_status?: string, order_status?: string, reference?: string, export_status?: string, send_status?: string, egress_type?: string, egress_id?: string, date_time?: string, sender?: string, receiver?: string, environment?: string, integration_name?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { environment?: string, sender?: string, receiver?: string, ingress_id?: string, egress_id?: string, transaction_id?: string, reference?: string, integration_name?: string, statuses?: string[], $keys: string[] }): Promise<{ result?: { id?: string, ingress_type?: string, ingress_id?: string, transaction_id?: string, translation_status?: string, import_status?: string, order_status?: string, reference?: string, export_status?: string, send_status?: string, egress_type?: string, egress_id?: string, date_time?: string, sender?: string, receiver?: string, environment?: string, integration_name?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      environment?: string, sender?: string, receiver?: string, ingress_id?: string, egress_id?: string, transaction_id?: string, reference?: string, integration_name?: string, statuses?: string[]    }) {
      return false;
    }
}
